import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import { CssBaseline } from '@material-ui/core';
import merge from 'lodash/merge';

const overrideTheme = (theme) => {
  theme.palette.secondary.main = '#212121';
  merge(theme.overrides, {
    SaveConfiguration: {
      dialogContentRoot: {
        minHeight: 163,
        '& .MuiTypography-root': {
          lineHeight: 1.7,
        },
      },
      successResult: {
        marginTop: 24,
        padding: '14px 8px',
        lineHeight: '28px',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      contained: {
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: '#616161',
        },
      },
    },
    AddVisualElement: {
      addVisualElementIconRoot: {
        paddingLeft: 0,
      },
      labelText: {
        minWidth: 130,
      },
    },
  });
};

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ConnectedThemeProvider withTheme={overrideTheme}>
      <CssBaseline />
      {children}
    </ConnectedThemeProvider>
  );
};

export default ThemeProvider;
